export default {
  lang_name: 'Portugues',
  tab_main: 'Principal', tab_upgrade: 'Melhoria', tab_prestige: 'Prestigio', tab_achievement: 'Conquistas', tab_mission: 'Missão', tab_domination: 'Mundo', tab_settings: 'Config.',
  hud_cps: '/s', hud_boost: 'Boost',
  main_tap_area: 'TOQUE!', main_combo: 'Combo',
  prod_informant: 'Informante', prod_informant_desc: 'Coleta de intel nas ruas',
  prod_hacker: 'Hacker', prod_hacker_desc: 'Infiltracao de redes humanas',
  prod_disguiser: 'Disfarce', prod_disguiser_desc: 'Camuflagem humana',
  prod_mindController: 'Controle Mental', prod_mindController_desc: 'Manipulacao de opiniao',
  prod_secretLab: 'Lab. Secreto', prod_secretLab_desc: 'Pesquisa reptiliana',
  prod_mediaCell: 'Celula de Midia', prod_mediaCell_desc: 'Controle de noticias',
  prod_shadowGovt: 'Gov. Sombra', prod_shadowGovt_desc: 'Substituicao de politicos',
  prod_deepBase: 'Base Profunda', prod_deepBase_desc: 'Mega-base subterranea',
  prod_orbitalStation: 'Estacao Orbital', prod_orbitalStation_desc: 'Rede de vigilancia satelital',
  prod_dimensionGate: 'Portal Dimensional', prod_dimensionGate_desc: 'Invocar forcas do lar',
  prod_planetController: 'Controle Planetario', prod_planetController_desc: 'Controle direto da Terra',
  prod_galacticBeacon: 'Farol Galactico', prod_galacticBeacon_desc: 'Linha direta com o QG',
  prod_locked: 'Desbloquear: ', prod_locked_prestige: 'Prestigio {n}x', prod_locked_time: '{n}min jogo',
  milestone_squad: 'Esquadrao', milestone_company: 'Companhia', milestone_battalion: 'Batalhao',
  milestone_regiment: 'Regimento', milestone_division: 'Divisao', milestone_corps: 'Corpo',
  click_basic_training: 'Treino Basico', click_combat_training: 'Treino de Combate',
  click_psychic_awaken: 'Despertar Psiquico', click_transform: 'Melhoria de Forma',
  click_telepathy: 'Telepatia', click_critical_eye: 'Olho Crítico',
  click_dimension_sense: 'Sentido Dimensional', click_galaxy_field: 'Campo Galactico',
  click_lethal_strike: 'Golpe Letal', click_absolute: 'Infiltracao Absoluta',
  click_planet_destroyer: 'Destruidor Planetario', click_galaxy_finger: 'Dedo do Overlord',
  special_info_network: 'Rede de Info', special_info_network_desc: 'Informante & Hacker x2',
  special_perfect_disguise: 'Disfarce Perfeito', special_perfect_disguise_desc: 'Todos agentes x1.5',
  special_mass_brainwash: 'Lavagem Cerebral em Massa', special_mass_brainwash_desc: 'Controle Mental & Midia x3',
  special_shadow_network: 'Rede Sombria', special_shadow_network_desc: 'Renda offline +25%',
  special_underground_empire: 'Imperio Subterraneo', special_underground_empire_desc: 'Todos agentes x2',
  special_orbital_surveillance: 'Vigilancia Orbital', special_orbital_surveillance_desc: 'Eventos dourados +50%',
  special_dimension_supply: 'Suprimento Dimensional', special_dimension_supply_desc: 'Renda de toque x5',
  special_galactic_alliance: 'Alianca Galactica', special_galactic_alliance_desc: '\uD83D\uDEF8 por segundo x10',
  special_combo_master: 'Mestre do Combo', special_combo_master_desc: 'Limite de combo x3',
  special_time_warp: 'Salto Temporal', special_time_warp_desc: 'Limite offline 12h',
  special_agent_synergy: 'Sinergia de Agentes', special_agent_synergy_desc: '\uD83D\uDEF8 por segundo x1.5',
  special_massive_infiltration: 'Infiltracao Massiva', special_massive_infiltration_desc: '\uD83D\uDEF8 por segundo x2',
  subtab_click: 'Clique', subtab_special: 'Especial',
  prestige_title: 'Reestruturacao', prestige_total_ip: '🛸 total ganho', prestige_gc_gain: '💎 a ganhar',
  prestige_gc_current: '💎 atual', prestige_execute: 'Reestruturar',
  prestige_confirm: 'Resetar todo progresso por {gc} Creditos Galacticos?',
  prestige_ad_bonus: 'Ver anuncio +50% 💎', prestige_requirement: 'Precisa de 10B+ 🛸',
  prestige2_title: 'Reestruturacao Galactica', prestige2_cores_gain: '🔮 a ganhar',
  prestige2_cores_current: '🔮 atuais', prestige2_execute: 'Reestruturacao Galactica',
  prestige2_requirement: 'Precisa de 15+ prestigios e 100+ 💎', prestige2_confirm: 'Reset profundo por {cores} Nucleos Galacticos?',
  pup_galaxy_mult: 'Multiplicador Galactico', pup_galaxy_mult_desc: 'CPS x1.5 por nível (acumula multiplicativamente)',
  pup_infil_accel: 'Aceleracao de Infiltracao', pup_infil_accel_desc: 'Começar com 100M 🛸 por nível após prestígio',
  pup_tap_enhance: 'Melhoria de Toque', pup_tap_enhance_desc: 'Renda por toque x2 por nível (acumula)',
  pup_offline_expand: 'Expansao Offline', pup_offline_expand_desc: 'Limite recompensa offline +1h/Nv (base 8h)',
  pup_offline_eff: 'Eficiencia Offline', pup_offline_eff_desc: 'Taxa de renda offline +10%p/Nv (base 50%)',
  pup_agent_discount: 'Desconto de Agente', pup_agent_discount_desc: 'Custo de agentes -10% por nível (máx -50%)',
  pup_auto_click: 'Auto Clique', pup_auto_click_desc: 'Auto-toque 3/seg por nível (máx 15/seg)',
  pup_golden_luck: 'Sorte Dourada', pup_golden_luck_desc: 'Recompensa evento dourado +20%/Nv (máx +200%)',
  pup_combo_keep: 'Manter Combo', pup_combo_keep_desc: 'Duração combo +0.5s/Nv (base 2s)',
  pup_quick_start: 'Inicio Rapido', pup_quick_start_desc: 'Receber 1 dos primeiros 5 agentes após prestígio',
  p2up_galaxy_speed: 'Velocidade Galactica', p2up_galaxy_speed_desc: '💎 ganhos x2 por nível no prestígio (acumulável)',
  p2up_auto_prestige: 'Auto Prestigio', p2up_auto_prestige_desc: 'Prestígio automático ao atingir 10B 🛸',
  p2up_permanent: 'Agentes Permanentes', p2up_permanent_desc: 'Manter primeiros 3 tipos de agentes após prestígio',
  p2up_dimension_accel: 'Aceleracao Dimensional', p2up_dimension_accel_desc: 'CPS x5 por nível (acumulável, permanente)',
  p2up_galaxy_memory: 'Memoria Galactica', p2up_galaxy_memory_desc: 'Manter 3 bônus ativos após prestígio',
  p2up_spacetime: 'Curvatura Espacotemporal', p2up_spacetime_desc: 'Taxa de renda offline 100% (permanente)',
  p2up_automate: 'Automacao Galactica', p2up_automate_desc: 'Contratar agentes automaticamente (permanente)',
  rank_e: 'Estagiario', rank_d: 'Agente Junior', rank_c: 'Agente', rank_b: 'Agente Senior',
  rank_a: 'Executivo', rank_s: 'Diretor', rank_ss: 'Comandante Supremo', rank_sss: 'Overlord Galactico',
  ach_title: 'Conquistas', ach_filter_all: 'Todos', ach_filter_tap: 'Toque', ach_filter_resource: 'Recurso',
  ach_filter_producer: 'Produtor', ach_filter_prestige: 'Prestigio', ach_filter_time: 'Tempo',
  ach_filter_special: 'Especial', ach_filter_ad: 'Docs', ach_filter_combo: 'Combo',
  ach_t01: 'Primeiro Passo', ach_t01_reward: '+1 Poder de Toque', ach_t02: 'Aquecimento', ach_t02_reward: '+5% Poder de Toque',
  ach_t03: 'Agente Constante', ach_t03_reward: '+10% Poder de Toque', ach_t04: 'Mestre do Toque', ach_t04_reward: '+15% Poder de Toque',
  ach_t05: 'Determinacao Reptiliana', ach_t05_reward: '+20% Poder de Toque', ach_t06: 'Dedos Galacticos', ach_t06_reward: '+25% Poder de Toque',
  ach_t07: 'Aprendiz de Combo', ach_t07_reward: '+0.5s Combo', ach_t08: 'Mestre do Combo', ach_t08_reward: '+0.5 Limite Combo',
  ach_r01: 'Pequena Intel', ach_r01_reward: '+5% \u{1F6F8}/s', ach_r02: 'Coletor de Intel', ach_r02_reward: '+5% \u{1F6F8}/s',
  ach_r03: 'Cofre Classificado', ach_r03_reward: '+5% \u{1F6F8}/s', ach_r04: 'Infiltracao Milionaria', ach_r04_reward: '+10% \u{1F6F8}/s',
  ach_r05: 'Agente Bilionario', ach_r05_reward: '+10% \u{1F6F8}/s', ach_r06: 'Ops Trilhao', ach_r06_reward: '+15% \u{1F6F8}/s',
  ach_r07: 'Imperio Quatrilhao', ach_r07_reward: '+15% \u{1F6F8}/s', ach_r08: 'Oceano Galactico', ach_r08_reward: '+20% \u{1F6F8}/s',
  ach_r09: 'Universo Cosmico', ach_r09_reward: '+20% \u{1F6F8}/s', ach_r10: 'Infiltracao Infinita', ach_r10_reward: '+30% \u{1F6F8}/s',
  ach_g01: 'Primeiro Recruta', ach_g01_reward: 'Informante x1.5', ach_g02: 'Rede de Intel', ach_g02_reward: 'Informante x2',
  ach_g03: 'Hackear Comecou', ach_g03_reward: 'Hacker x2', ach_g04: 'Legiao Cyber', ach_g04_reward: 'Hacker x3',
  ach_g05: 'Mestre do Disfarce', ach_g05_reward: 'Disfarce x2', ach_g06: 'Rede de Lavagem', ach_g06_reward: 'Controle Mental x2',
  ach_g07: 'Ciencia Louca', ach_g07_reward: 'Lab. Secreto x2', ach_g08: 'Controle de Midia', ach_g08_reward: 'Celula de Midia x2',
  ach_g09: 'Gabinete Sombra', ach_g09_reward: 'Gov. Sombra x2', ach_g10: 'Imperio Subterraneo', ach_g10_reward: 'Base Profunda x2',
  ach_g11: 'Dominio Orbital', ach_g11_reward: 'Estacao Orbital x2', ach_g12: 'Mestre da Galaxia', ach_g12_reward: '\u{1F6F8}/s Total x2',
  ach_p01: 'Primeira Reestruturacao', ach_p01_reward: '+5 💎 Bonus', ach_p02: 'Gosto do Ciclo', ach_p02_reward: '+10% 💎',
  ach_p03: 'Veterano', ach_p03_reward: '+10% 💎', ach_p04: 'Viciado em Prestigio', ach_p04_reward: '+15% 💎',
  ach_p05: 'Loop Infinito', ach_p05_reward: '+20% 💎', ach_p06: 'Memoria Galactica', ach_p06_reward: '+25% 💎',
  ach_p07: 'Reestruturacao Galactica', ach_p07_reward: '+3 🔮 Bonus', ach_p08: 'Senhor Dimensional', ach_p08_reward: '+20% 🔮',
  ach_h01: 'Novo Recruta', ach_h01_reward: 'Bonus Boas-vindas 100 🛸', ach_h02: 'Turno de 1 Hora', ach_h02_reward: '+5% \u{1F6F8}/s',
  ach_h03: 'Meio Dia', ach_h03_reward: '+10% \u{1F6F8}/s', ach_h04: 'Vigia 24h', ach_h04_reward: 'Offline +2h',
  ach_h05: 'Missao de 3 Dias', ach_h05_reward: '\u{1F6F8}/s x1.5', ach_h06: 'Infiltracao Semanal', ach_h06_reward: '\u{1F6F8}/s x2',
  ach_s01: 'Humano Suspeito', ach_s01_reward: '1 Doc', ach_s02: 'Inicio Limpo', ach_s02_reward: 'Titulo: Agente Temerario',
  ach_s03: 'Tudo Dentro', ach_s03_reward: '+10% \u{1F6F8}/s', ach_s04: 'Speed Run', ach_s04_reward: '+10 💎 Bonus',
  ach_s05: 'Cacador Dourado', ach_s05_reward: 'Freq evento -20%', ach_s06: 'Agente Noturno', ach_s06_reward: '\u{1F6F8}/s noturno x1.5',
  ach_s07: 'Guerreiro F2P', ach_s07_reward: 'Recompensa ad +30%', ach_s08: 'Colecionador', ach_s08_reward: '\u{1F6F8}/s x3',
  ach_a01: 'Iniciante em Ads', ach_a01_reward: '1 Doc', ach_a02: 'Entusiasta de Ads', ach_a02_reward: '2 Docs',
  ach_a03: 'Mestre de Ads', ach_a03_reward: 'Recompensa ad +30%', ach_a04: 'Coletor de Docs', ach_a04_reward: 'Efeito doc +20%',
  ach_a05: 'Especialista em Docs', ach_a05_reward: 'Efeito doc +50%',
  ach_c01: 'Inicio Combo', ach_c01_reward: '+0.3s Combo', ach_c02: 'No Ritmo', ach_c02_reward: '+0.1 Mult Combo',
  ach_c03: 'Iniciante Dourado', ach_c03_reward: 'Recompensa evento +10%', ach_c04: 'Coletor Dourado', ach_c04_reward: 'Freq evento -10%',
  ach_c05: 'Maniaco Diario', ach_c05_reward: 'Recompensa missao +50%',
  golden_intel_leak: 'Vazamento de Intel!', golden_agent_frenzy: 'Frenesi de Agentes!', golden_money_launder: 'Lavagem de Dinheiro!',
  golden_facility_boost: 'Sobrecarga!', golden_supply_drop: 'Suprimento Galactico!', golden_touch: 'TOQUE!',
  golden_ad_double: 'Ver anuncio para 2x',
  offline_title: 'Relatorio de Ausencia', offline_elapsed: 'Tempo decorrido', offline_earned: '🛸 ganho',
  offline_cap: 'Max {h}h aplicado', offline_claim: 'Resgatar', offline_double: 'Ver anuncio para 2x ({amount})',
  offline_hours: '{h}h {m}m',
  settings_title: 'Configuracoes', settings_bgm: 'BGM', settings_sfx: 'SFX', settings_lang: 'Idioma',
  settings_reset: 'Resetar Jogo', settings_reset_confirm: 'Apagar TODO o progresso?',
  settings_stats: 'Estatisticas', settings_total_ip: '🛸 Total Ganho', settings_total_taps: 'Toques Totais',
  settings_total_prestiges: 'Prestigios Totais', settings_play_time: 'Tempo Total', settings_docs_shop: 'Loja de Docs',
  doc_shop_title: 'Loja de Docs Classificados',
  doc_ip_boost: 'Acelerador de Renda', doc_ip_boost_desc: '2x producao 🛸/s por 30 seg',
  doc_mega_tap: 'Treino de Toque Forte', doc_mega_tap_desc: '3x renda de toque por 30 seg',
  doc_auto_click: 'Auto-Infiltrador', doc_auto_click_desc: 'Auto-toque 10/seg por 30 seg',
  doc_instant_golden: 'Chamada Dourada', doc_instant_golden_desc: 'Ativar evento dourado instantaneamente',
  doc_timeskip: 'Acelerador Temporal', doc_timeskip_desc: 'Obter 2 horas de renda 🛸 instantaneamente',
  doc_prestige_boost: 'Amplificador Galactico', doc_prestige_boost_desc: '2x 💎 no proximo prestigio',
  doc_prestige_boost_active: '💎 x2 pendente para proximo prestigio', doc_prestige_boost_active_badge: '✅ Ativo',
  ad_offline_double: 'Dobro da recompensa offline', ad_cps_boost: 'Renda/s x10 Boost (15s)',
  ad_prestige_bonus: 'Prestigio +50% 💎', ad_timeskip: 'Salto Temporal (2h)', ad_free_docs: 'Docs Gratis',
  ad_golden_double: 'Dobro recompensa dourada', ad_start_boost: 'Pack de Inicio',
  ad_watching: 'Carregando anuncio...', ad_cooldown: 'Disponivel em {t}',
  settings_sfx_test: 'Testar SFX', settings_sound_reset: 'Redefinir', settings_sound_reset_done: 'Som redefinido',
  num_k: 'K', num_m: 'M', num_b: 'B', num_t: 'T', num_qa: 'Qa', num_qi: 'Qi', num_sx: 'Sx', num_sp: 'Sp', num_oc: 'Oc', num_no: 'No', num_dc: 'Dc',
  mission_title: 'Missoes Diarias',
  mission_claim: 'Resgatar',
  mission_all_complete: 'Bonus Completo!',
  mission_clear_label: 'MISS\u00C3O',
  mission_all_clear_label: 'COMPLETO',
  ach_unlock_label: 'CONQUISTA',
  mission_diff_easy: 'Facil',
  mission_diff_normal: 'Medio',
  mission_diff_hard: 'Dificil',
  mission_tap_100: 'Toque Leve',
  mission_tap_100_desc: 'Tocar 100 vezes',
  mission_tap_300: 'Maos Quentes',
  mission_tap_300_desc: 'Tocar 300 vezes',
  mission_buy_5: 'Pequeno Recruta',
  mission_buy_5_desc: 'Comprar 5 produtores',
  mission_combo_10: 'Inicio Combo',
  mission_combo_10_desc: 'Alcancar 10 combo',
  mission_golden_1: 'Sorte Grande',
  mission_golden_1_desc: 'Pegar 1 evento dourado',
  mission_tap_1000: 'Mao Pesada',
  mission_tap_1000_desc: 'Tocar 1.000 vezes',
  mission_buy_20: 'Construtor de Esquadrao',
  mission_buy_20_desc: 'Comprar 20 produtores',
  mission_combo_50: 'Combo Pro',
  mission_combo_50_desc: 'Alcancar 50 combo',
  mission_golden_3: 'Corrida do Ouro',
  mission_golden_3_desc: 'Pegar 3 eventos dourados',
  mission_earn_1m: 'Ops Milhao',
  mission_earn_1m_desc: 'Ganhar 1M 🛸',
  mission_tap_5000: 'Maquina de Toques',
  mission_tap_5000_desc: 'Tocar 5.000 vezes',
  mission_buy_50: 'Construtor de Exercito',
  mission_buy_50_desc: 'Comprar 50 produtores',
  mission_combo_100: 'Deus do Combo',
  mission_combo_100_desc: 'Alcancar 100 combo',
  mission_golden_5: 'Mestre Dourado',
  mission_golden_5_desc: 'Pegar 5 eventos dourados',
  mission_earn_1b: 'Agente Bilionario',
  mission_earn_1b_desc: 'Ganhar 1B 🛸',
  mission_tap_200: 'Dedos rápidos',
  mission_tap_200_desc: 'Toque 200 vezes',
  mission_buy_3: 'Primeiros recrutas',
  mission_buy_3_desc: 'Compre 3 produtores',
  mission_combo_15: 'Combo iniciante',
  mission_combo_15_desc: 'Alcance 15 combo',
  mission_earn_10k: 'Dinheiro de bolso',
  mission_earn_10k_desc: 'Ganhe 10K 🛸',
  mission_earn_100k: 'Arrecadador',
  mission_earn_100k_desc: 'Ganhe 100K 🛸',
  mission_tap_500: 'Toque constante',
  mission_tap_500_desc: 'Toque 500 vezes',
  mission_tap_700: 'Imparável',
  mission_tap_700_desc: 'Toque 700 vezes',
  mission_buy_10: 'Líder de equipe',
  mission_buy_10_desc: 'Compre 10 produtores',
  mission_combo_30: 'Corrente de combo',
  mission_combo_30_desc: 'Alcance 30 combo',
  mission_golden_2: 'Ouro duplo',
  mission_golden_2_desc: 'Pegue 2 eventos dourados',
  mission_tap_3000: 'Guerreiro do toque',
  mission_tap_3000_desc: 'Toque 3.000 vezes',
  mission_buy_30: 'Batalhão',
  mission_buy_30_desc: 'Compre 30 produtores',
  mission_combo_75: 'Combo elite',
  mission_combo_75_desc: 'Alcance 75 combo',
  mission_golden_4: 'Caçador de ouro',
  mission_golden_4_desc: 'Pegue 4 eventos dourados',
  mission_earn_10m: 'Magnata',
  mission_earn_10m_desc: 'Ganhe 10M 🛸',

  // Conquest
  cq_title: 'Conquista Mundial',
  cq_progress: 'Conquistado',
  cq_infiltration_power: 'Poder de Infiltração',
  cq_active_conquest: 'Infiltrando',
  cq_infiltration_progress: 'Progresso de Infiltração',
  cq_time_remaining: 'Tempo estimado',
  cq_start_infiltration: 'Iniciar Infiltração',
  cq_stop_infiltration: 'Parar Infiltração',
  cq_no_power_hint: 'Contrate agentes para gerar poder de infiltração',
  cq_locked: 'Bloqueado',
  cq_available: 'Disponível',
  cq_conquered: 'Conquistado',
  cq_popup_title: 'Conquista Completa!',
  cq_popup_desc: 'foi conquistado! Construa instalações para ficar mais forte.',
  cq_back: 'Voltar',
  cq_invest_title: 'Investir 🛸 para conquistar',
  cq_current_ip: '🛸 atual',
  cq_facilities: 'Instalações',
  cq_build: 'Construir',
  cq_upgrade: 'Melhorar',
  cq_next_level: 'Próximo',
  cq_counter_intel_title: 'Alerta de contraespionagem!',
  cq_counter_intel_text: 'Sua infiltração em {country} foi detectada! O progresso será reduzido.',
  cq_defend_ad: 'Assistir anúncio para defender',
  cq_accept_loss: 'Aceitar perda',
  cq_ending_title: 'Terra conquistada!',
  cq_ending_text: 'A conspiração reptiliana está completa. Todas as nações se curvam ao império das sombras.',
  cq_ending_time: 'Tempo de jogo',
  cq_ending_prestiges: 'Prestígios',
  cq_ending_total_ip: '🛸 total',
  cq_ending_taps: 'Toques totais',
  cq_ending_continue: 'Continuar jogando',
  cq_egypt: 'Egito', cq_egypt_desc: 'Bases antigas das pirâmides',
  cq_brazil: 'Brasil', cq_brazil_desc: 'Esconderijos na selva amazônica',
  cq_india: 'Índia', cq_india_desc: 'Infiltração do culto Naga',
  cq_australia: 'Austrália', cq_australia_desc: 'Bunkers subterrâneos do deserto',
  cq_japan: 'Japão', cq_japan_desc: 'Roubo de tecnologia',
  cq_korea: 'Coreia', cq_korea_desc: 'Brecha ciberdefesa NIS',
  cq_uk: 'Reino Unido', cq_uk_desc: 'Infiltração real MI5/MI6',
  cq_russia: 'Rússia', cq_russia_desc: 'Operações siberianas FSB',
  cq_china: 'China', cq_china_desc: 'Vigilância mais forte do mundo',
  cq_usa: 'Estados Unidos', cq_usa_desc: 'CIA/NSA chefe final',
  fac_pyramid_vault: 'Cofre Pirâmide', fac_pyramid_vault_d: '\u{1F6F8}/s +5% por nível',
  fac_nile_network: 'Rede do Nilo', fac_nile_network_d: 'Offline +5% por nível',
  fac_ancient_lab: 'Lab Antigo', fac_ancient_lab_d: 'TAP +10% por nível',
  fac_amazon_hideout: 'Esconderijo Amazônico', fac_amazon_hideout_d: 'Desconto +2% por nível',
  fac_samba_broadcast: 'Transmissão Samba', fac_samba_broadcast_d: '\u{1F6F8}/s +8% por nível',
  fac_jungle_lab: 'Lab da Selva', fac_jungle_lab_d: 'Golden +5% por nível',
  fac_naga_temple: 'Templo Naga', fac_naga_temple_d: '💎 +5% por nível',
  fac_bollywood_studio: 'Estúdio Bollywood', fac_bollywood_studio_d: 'Offline +8% por nível',
  fac_caste_network: 'Rede de Castas', fac_caste_network_d: '\u{1F6F8}/s +12% por nível',
  fac_desert_bunker: 'Bunker do Deserto', fac_desert_bunker_d: 'TAP +15% por nível',
  fac_ayers_signal: 'Sinal Ayers', fac_ayers_signal_d: 'Golden +8% por nível',
  fac_outback_base: 'Base Outback', fac_outback_base_d: '\u{1F6F8}/s +15% por nível',
  fac_akiba_ai: 'IA Akihabara', fac_akiba_ai_d: '\u{1F6F8}/s +20% por nível',
  fac_ninja_intel: 'Intel Ninja', fac_ninja_intel_d: 'Desconto +3% por nível',
  fac_tokyo_tower: 'Torre de Tóquio', fac_tokyo_tower_d: '💎 +8% por nível',
  fac_gangnam_hq: 'QG Gangnam', fac_gangnam_hq_d: '\u{1F6F8}/s +25% por nível',
  fac_cyber_command: 'Comando Cibernético', fac_cyber_command_d: 'TAP +25% por nível',
  fac_kpop_brainwash: 'Lavagem K-Pop', fac_kpop_brainwash_d: '💎 +10% por nível',
  fac_royal_infiltrate: 'Infiltração Real', fac_royal_infiltrate_d: '\u{1F6F8}/s +30% por nível',
  fac_london_tower: 'Torre de Londres', fac_london_tower_d: 'Offline +15% por nível',
  fac_mi6_double: 'Agente Duplo MI6', fac_mi6_double_d: 'Golden +12% por nível',
  fac_siberia_base: 'Base Sibéria', fac_siberia_base_d: '\u{1F6F8}/s +40% por nível',
  fac_kgb_remnant: 'Remanescente KGB', fac_kgb_remnant_d: 'Desconto +5% por nível',
  fac_nuke_bunker: 'Bunker Nuclear', fac_nuke_bunker_d: 'TAP +40% por nível',
  fac_great_wall: 'Grande Firewall', fac_great_wall_d: '\u{1F6F8}/s +50% por nível',
  fac_shenzhen_factory: 'Fábrica Shenzhen', fac_shenzhen_factory_d: 'Desconto +8% por nível',
  fac_panda_spy: 'Rede Espião Panda', fac_panda_spy_d: 'Golden +20% por nível',
  fac_area51: 'Área 51', fac_area51_d: '\u{1F6F8}/s +80% por nível',
  fac_pentagon: 'Pentágono', fac_pentagon_d: 'TAP +80% por nível',
  fac_wall_street: 'Wall Street', fac_wall_street_d: '💎 +25% por nível',

  buy: 'Comprar', max: 'MAX', level: 'Nv.', locked: 'Bloqueado', unlocked: 'Desbloqueado',
  upgrade_locked_prev: 'Aprenda a melhoria anterior primeiro',
  condition: 'Condicao', cost: 'Custo', owned: 'Possuido', effect: 'Efeito', reward: 'Recompensa',
  close: 'Fechar', confirm: 'Confirmar', cancel: 'Cancelar',

  // Conquest achievements
  ach_filter_conquest: 'Conquista',
  ach_q01: 'Primeira Conquista', ach_q01_reward: '\u{1F6F8}/s +10%',
  ach_q02: 'Tripla Ameaça', ach_q02_reward: 'TAP +10%',
  ach_q03: 'Metade do Mundo', ach_q03_reward: '💎 +15%',
  ach_q04: 'Sete Bandeiras', ach_q04_reward: 'Offline +20%',
  ach_q05: 'Dominador Mundial', ach_q05_reward: '\u{1F6F8}/s x3',
  ach_q06: 'Mestre de Instalações', ach_q06_reward: '\u{1F6F8}/s x2',
  milestone_next: 'Próximo',
  settings_conquest: 'Conquista',

  // Currency info
  currency_ip_name: 'Pontos de Infiltração (IP)',
  currency_ip_earn: 'Toque, produção automática, renda offline e recompensas de anúncios',
  currency_ip_use: 'Contratar agentes, comprar melhorias, investir em conquistas',
  currency_gc_name: 'Créditos Galácticos (GC)',
  currency_gc_earn: 'Ao fazer prestige (Reestruturação) com base no IP total acumulado',
  currency_gc_use: 'Comprar melhorias de prestige (multiplicador de produ\u00E7\u00E3o, eficiência offline, etc.)',
  currency_cores_name: 'Núcleos Galácticos',
  currency_cores_earn: 'Ao fazer 2º prestige (Reestruturação Galáctica) com base no GC total',
  currency_cores_use: 'Comprar melhorias de 2º prestige (buffs permanentes, automação, etc.)',
  currency_docs_name: 'Documentos Classificados',
  currency_docs_earn: 'Missões diárias, assistir anúncios ou desbloquear conquistas',
  currency_docs_use: 'Comprar boosts poderosos na Loja de Docs (aba Missão)',
  currency_how_earn: 'Como obter',
  currency_how_use: 'Como usar',

  // Prestige upgrades - conquest
  pup_infiltration_mastery: 'Maestria de Infiltração',
  pup_infiltration_mastery_desc: 'Poder de infiltração total +50%/Nv (máx +500%)',
  pup_agent_network: 'Rede de Agentes',
  pup_agent_network_desc: 'Infiltração +5% por 100 agentes por nível',
  pup_quick_infiltration: 'Infiltração em Cadeia',
  pup_quick_infiltration_desc: 'Ao conquistar: próximo país +10% progresso/Nv',
  pup_critical_chance: 'Treinamento Crítico',
  pup_critical_chance_desc: 'Chance de crítico +3%/Nv (base 10%, máx 50%)',
  pup_critical_damage: 'Poder Crítico',
  pup_critical_damage_desc: 'Dano crítico +1x/Nv (base x3)',

  // Special upgrades - conquest
  special_spy_master: 'Mestre Espião',
  special_spy_master_desc: 'Poder de infiltração total x2',

  ad_income_x5: 'Renda de 30min',
  ad_income_x5_desc: 'Assista um anúncio para receber\n{amount} 🛸 instantaneamente (30 minutos de renda)!',
  ad_tap_x10: 'Toque x10 (10s)',
  ad_tap_x10_desc: 'Assista um anúncio para aumentar\na renda por toque x10 por 10 segundos!',
  ad_free_docs_desc: 'Assista um anúncio para receber\n1 Documento Classificado 📜 grátis!',
  ad_prestige_desc: 'Assista um anúncio para aumentar\nsua renda x10 por 15 segundos!',
  cq_tutorial_title: '🌍 Guia de Conquista Mundial',
  cq_tutorial_text: 'Após conquistar um país, você pode construir <b>instalações</b>!\nAtualize-as para bônus permanentes como\n<b>RPS, renda por toque, renda offline</b> e mais.\n\nContrate agentes para aumentar o poder de infiltração.',
  rank_promote: 'Promover',
  rank_promoted: 'Promoção concluída!',
} as const;
